<template>
  <div class="bill-item">
    <div class="section">
      <span>就诊卡： {{ info.icCode }}</span>
      <span
        >总金额：<span class="price">{{ info.totalAmount }}</span>
      </span>
    </div>
    <div class="section">
      <span>科室： {{ info.departmentName }}</span>
      <span>医生： {{ info.doctorName }}</span>
    </div>
    <div class="section">
      <span>发票号： {{ info.billNo }}({{ info.billBatchCode }})</span>
      <span>打印时间：{{ info.printDate }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    info: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  methods: {},
};
</script>
<style lang="less" scoped>
.bill-item {
  .section {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    .price {
      color: #f00;
    }
  }
}
</style>
